import { render, staticRenderFns } from "./ScopeOfWorksTask.vue?vue&type=template&id=7fff74d0&"
import script from "./ScopeOfWorksTask.vue?vue&type=script&lang=js&"
export * from "./ScopeOfWorksTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports